import { gql } from "@apollo/client";

export const CARD_LIST = gql`
  query getListCards {
    getListCards {
      cards {
        id,
        cardBrand,
        last4,
        cardholderName,
        customerId,
        cardType,
        expMonth,
        expYear,
        isDefault,
        hasSubscription,
        expiryStatus,
        isActive,
      },
      success,
      messages,
    }
  }
`;
